import { defineProperty as _defineProperty, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { getBaseReset } from '../../../styles-system/create-component.esm.js';
import { THEME_UI_DEFAULT_KEY } from '../../../theme-provider/types.esm.js';
import { ellipsis, isFlatDesign } from '../../../themes/const.esm.js';
import { EMPTY_OBJECT } from '../../../utils/object.esm.js';

var _THEME_UI_DEFAULT_KEY;
var _excluded = ["type"],
  _excluded2 = ["type"],
  _excluded3 = ["type"];
var INPUT_HOVER_PSEUDO_FIELD = '&:hover:not(.is-disabled, :focus-within, .is-read-only, .show-focus, .has-error)';
var INPUT_FOCUS_PSEUDO_FIELD = '&:not(.is-read-only):focus-within';
var standardStyles = function standardStyles(theme) {
  var isFlatDesign$1 = isFlatDesign(theme);
  return _objectSpread2(_objectSpread2({}, getBaseReset()), {}, {
    // provide reset to block style leak
    color: isFlatDesign$1 ? 'neutrals.0' : 'text',
    lineHeight: 'body',
    '&:not([readonly]).autocomplete-select': {
      cursor: 'pointer'
    }
  });
};
var disabledStyles = {
  '&[disabled]': {
    cursor: 'not-allowed',
    color: 'neutral.dark',
    borderColor: 'neutral.bold',
    '::selection': {
      color: 'none',
      background: 'none'
    },
    '::placeholder': {
      color: 'neutral.dark'
    }
  }
};
var focusStyles = {
  zIndex: '2'
};
var placeholderStyles = function placeholderStyles(theme) {
  var isFlatDesign$1 = isFlatDesign(theme);
  return {
    '::placeholder': {
      color: isFlatDesign$1 ? 'neutral.darker' : 'textSecondary'
    }
  };
};
var hoverStyles = {
  zIndex: '2',
  borderColor: 'neutrals.0'
};
var readOnlyStyles = function readOnlyStyles(theme) {
  var isFlatDesign$1 = isFlatDesign(theme);
  return {
    ':read-only:not(&[disabled]):not(.autocomplete-select)': {
      cursor: 'text',
      '&:focus-within': _objectSpread2(_objectSpread2({}, isFlatDesign$1 ? {} : {
        boxShadow: 'none'
      }), {}, {
        border: '0'
      })
    }
  };
};
var pointerStyles = {
  '&:not(&[disabled]):not(.is-disabled)': {
    cursor: 'pointer'
  }
};
var getFocusStyles = function getFocusStyles(theme, props) {
  var state = props.state,
    disableBorderEffect = props.disableBorderEffect;
  var isFlatDesign$1 = isFlatDesign(theme);
  return _objectSpread2(_objectSpread2({}, focusStyles), disableBorderEffect ? {} : _objectSpread2({
    borderColor: state ? state : 'primary.contrast'
  }, isFlatDesign$1 ? {} : {
    boxShadow: state ? state : 'primary'
  }));
};
var defaultInput = function defaultInput(theme, props) {
  var _objectSpread2$1;
  var mode = props.mode,
    state = props.state,
    readOnly = props.readOnly,
    disableBorderEffect = props.disableBorderEffect,
    _props$__inputProps = props.__inputProps,
    __inputProps = _props$__inputProps === void 0 ? EMPTY_OBJECT : _props$__inputProps;
  var type = __inputProps.type,
    rest = _objectWithoutProperties(__inputProps, _excluded);
  return _objectSpread2(_objectSpread2({
    borderRadius: 'default'
  }, disableBorderEffect ? {} : {
    border: '1px solid',
    borderColor: state ? state : 'neutral.medium'
  }), {}, (_objectSpread2$1 = {
    cursor: readOnly || mode !== 'select' ? 'text' : 'pointer',
    '&.is-disabled, &.is-read-only': {
      bg: 'neutral.subtlest',
      borderColor: 'neutral.bold'
    }
  }, _defineProperty(_objectSpread2$1, INPUT_FOCUS_PSEUDO_FIELD, getFocusStyles(theme, props)), _defineProperty(_objectSpread2$1, '&.show-focus', getFocusStyles(theme, props)), _defineProperty(_objectSpread2$1, INPUT_HOVER_PSEUDO_FIELD, _objectSpread2({}, hoverStyles)), _defineProperty(_objectSpread2$1, "input[type=\"".concat(type, "\"]"), _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, standardStyles(theme)), placeholderStyles(theme)), disabledStyles), readOnlyStyles(theme)), ellipsis), {}, {
    cursor: readOnly || mode !== 'select' ? 'text' : 'pointer'
  }, rest)), _defineProperty(_objectSpread2$1, "input[type=\"".concat(type, "\"].placeholder-as-value"), {
    '::placeholder': {
      color: 'text'
    }
  }), _defineProperty(_objectSpread2$1, ".csg-tui-".concat(type, "-input-msg"), {
    color: state ? state : 'textSecondary'
  }), _objectSpread2$1));
};
var input = (_THEME_UI_DEFAULT_KEY = {}, _defineProperty(_THEME_UI_DEFAULT_KEY, THEME_UI_DEFAULT_KEY, defaultInput), _defineProperty(_THEME_UI_DEFAULT_KEY, 'date-picker', function datePicker(theme, props) {
  var _forms, _basePreset$THEME_UI_;
  var _props$__inputProps2 = props.__inputProps,
    __inputProps = _props$__inputProps2 === void 0 ? EMPTY_OBJECT : _props$__inputProps2;
  var type = __inputProps.type,
    rest = _objectWithoutProperties(__inputProps, _excluded2);
  var basePreset = theme === null || theme === void 0 ? void 0 : (_forms = theme.forms) === null || _forms === void 0 ? void 0 : _forms.input;
  var baseVariant = (_basePreset$THEME_UI_ = basePreset[THEME_UI_DEFAULT_KEY]) !== null && _basePreset$THEME_UI_ !== void 0 ? _basePreset$THEME_UI_ : defaultInput;
  return _objectSpread2(_objectSpread2({}, baseVariant(theme, props)), {}, _defineProperty({
    '&.is-read-only': {
      bg: 'unset'
    }
  }, "input[type=\"".concat(type, "\"]"), _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, standardStyles(theme)), placeholderStyles(theme)), disabledStyles), ellipsis), pointerStyles), rest)));
}), _defineProperty(_THEME_UI_DEFAULT_KEY, 'read-only', function readOnly(theme, props) {
  var _forms2, _basePreset$THEME_UI_2;
  var _props$__inputProps3 = props.__inputProps,
    __inputProps = _props$__inputProps3 === void 0 ? EMPTY_OBJECT : _props$__inputProps3;
  var type = __inputProps.type,
    rest = _objectWithoutProperties(__inputProps, _excluded3);
  var isFlatDesign$1 = isFlatDesign(theme);
  var basePreset = theme === null || theme === void 0 ? void 0 : (_forms2 = theme.forms) === null || _forms2 === void 0 ? void 0 : _forms2.input;
  var baseVariant = (_basePreset$THEME_UI_2 = basePreset[THEME_UI_DEFAULT_KEY]) !== null && _basePreset$THEME_UI_2 !== void 0 ? _basePreset$THEME_UI_2 : defaultInput;
  return _objectSpread2(_objectSpread2({}, baseVariant(theme, props)), {}, _defineProperty({}, "input[type=\"".concat(type, "\"]"), _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, standardStyles(theme)), placeholderStyles(theme)), disabledStyles), {}, {
    ':read-only:not(&[disabled])': {
      cursor: 'text',
      '&:focus-within': _objectSpread2(_objectSpread2({}, isFlatDesign$1 ? {} : {
        boxShadow: 'none'
      }), {}, {
        border: '0'
      })
    }
  }, ellipsis), rest)));
}), _THEME_UI_DEFAULT_KEY);

export default input;
export { INPUT_FOCUS_PSEUDO_FIELD, INPUT_HOVER_PSEUDO_FIELD };
//# sourceMappingURL=variants.esm.js.map
